// Crayon's own art: the champion's cup, drawn by hand (LOOKS.md Part 1, "Art").

import type { CupProps } from '../define';

/**
 * Crayon's cup: drawn by hand, crooked on purpose, colored in with hatching in
 * the team's primary and outlined in its secondary, through the look's wobble.
 */
export function CrayonCup({ primary, secondary, size = 64 }: CupProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden>
      <defs>
        <pattern
          id={`fsp-cup-hatch-${primary.slice(1)}`}
          width="5"
          height="5"
          patternUnits="userSpaceOnUse"
          patternTransform="rotate(28)"
        >
          <rect width="5" height="5" fill={primary} fillOpacity="0.35" />
          <line x1="0" y1="0" x2="0" y2="5" stroke={primary} strokeWidth="2.6" />
        </pattern>
      </defs>
      <g filter="url(#crayon-wobble-sm)" strokeLinecap="round" strokeLinejoin="round">
        <path
          d="M17.5 8.6 C 26 7.6, 38 8.4, 46.6 7.8 C 46.9 13, 47.2 18.4, 46 22.6 C 44 30, 37.6 34.8, 31.6 34.6 C 25 34.4, 19.4 29.6, 18.2 22.4 C 17.6 17.6, 17.8 12.8, 17.5 8.6 Z"
          fill={`url(#fsp-cup-hatch-${primary.slice(1)})`}
          stroke={secondary}
          strokeWidth="2.6"
        />
        <path
          d="M17.8 12.4 C 13 11.8, 8.6 12.2, 7.6 14.6 C 7.2 21, 11.6 26.4, 18.6 27.4 M46.4 12 C 51 11.4, 55.8 12, 56.6 14.8 C 57 21.4, 52.4 26.6, 45.6 27.6"
          fill="none"
          stroke={secondary}
          strokeWidth="2.8"
        />
        <path
          d="M28.4 35 C 28.8 38, 28.2 41.4, 28.6 44.2 M35.4 35 C 35 38.2, 35.8 41, 35.2 44.4"
          fill="none"
          stroke={secondary}
          strokeWidth="2.6"
        />
        <path
          d="M20.6 44.6 C 28 43.8, 36.4 44.8, 43.6 44.2 C 43.8 46, 43.4 47.6, 43.8 49.2 C 36 49.8, 28 49, 20.2 49.6 C 20.6 47.8, 20.2 46.2, 20.6 44.6 Z"
          fill={primary}
          stroke={secondary}
          strokeWidth="2.2"
        />
        <path
          d="M16.4 49.8 C 26.6 49.2, 37.4 50.2, 47.8 49.4 C 48.2 52, 47.6 54.4, 48 56.6 C 37.6 57.2, 26.4 56.4, 16 57 C 16.6 54.6, 16 52.2, 16.4 49.8 Z"
          fill={secondary}
          stroke={secondary}
          strokeWidth="1.6"
        />
        <path
          d="M24 14 C 23.4 18, 24.2 22, 26 25.4"
          fill="none"
          stroke="#ffffff"
          strokeOpacity="0.6"
          strokeWidth="2.4"
        />
      </g>
    </svg>
  );
}
